module.exports = {
	"naslov": "Na Ravnoj gori",
	"slika": "fotke/1941/1941-05-ravna-gora.jpg",
	"opis": "Pridružio si se grupi nepredatih pripadnika Jugoslovenske vojske, koju predvodi pukovnik Mihailović. Za okupacionu vlast, svi koji nisu položili oružje, postaju odmetnici.",
	"pitanje": "Šta ćeš učiniti?",
	"izbori": [
		{
			"opis": "Ostaću sa četnicima",
			"link": "mmmm"
		},
		{
			"opis": "Prićiću komunistima",
			"link": "1941-07-07-zakletva"
		},
		{
			"opis": "Vratiću se kući.",
			"link": "bbbbb"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/hronologija/1941/05-15/ravna-gora.json
// module id = 41
// module chunks = 0